/** BerechtigungsgruppenPage — Administration › Berechtigungsgruppen (AC4, kind='gruppe'). */
import { ADMIN_PAGE_META } from '../adminNav';
import { RolesPageBase } from './RolesPageBase';

const meta = ADMIN_PAGE_META.berechtigungsgruppen;

export function BerechtigungsgruppenPage() {
  return (
    <RolesPageBase
      kind="gruppe"
      title={meta.title}
      description={meta.description}
      createLabel="Neue Gruppe"
      emptyLabel="Noch keine Berechtigungsgruppen. Gruppen wirken additiv zur Rolle."
    />
  );
}
